/**
  * EventBus
  * ========
  * Global event bus for transmitting messages application wide.
  *
  * Usage
  * -----
  * import { EventBus } from '@/EventBus.js';
  *
  * EventBus.dispatchErrorEvent('Whoops! Something went wrong, please try again.'  );
  */

import Vue from 'vue';
export const EventBus = new Vue();


/**
  * Dispatch an error Event
  *
  * @param message { string } The error message
  * @param options { array } An array of option objects
  */
EventBus.dispatchErrorEvent = function(message, options)
{
  EventBus.$emit('errorEvent', message, options);
}


/**
  * Dispatch a dialog event
  *
  * @param message { string } The message
  * @param options { array } An array of option objects
  */
EventBus.dispatchDialogEvent = function(message, options)
{
  EventBus.$emit('dialogEvent', message, options);
}



// WEBPACK FOOTER //
// ./src/EventBus.js